import { cn } from '../../shared/lib/cn'

export function formatCurrency(value: number, compact = false) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: compact ? 0 : 2,
    notation: compact ? 'compact' : 'standard',
  }).format(value || 0)
}

export function statusBadgeClass(status: string) {
  return cn(
    'inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold',
    status === 'review'
      ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
      : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  )
}

export function severityBadgeClass(severity: string) {
  return cn(
    'inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold capitalize',
    severity === 'blocker'
      ? 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300'
      : severity === 'warning'
        ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
        : 'bg-gray-100 text-gray-700 dark:bg-dark-surface-2 dark:text-gray-300',
  )
}
